
import { Mixins, Component, Watch } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import ETable from "@/components/ETable.vue";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";
import EditDialog from "./components/editDialog.vue";
import ProjectDialog from "./components/projectDialog.vue";
import newProjectDialog from "./components/newProjectDialog.vue";
import { symptomsInfoList, updateStatus, getSymptomsById, getPlanById, getNewPlanById } from "@/api/symptoms";
import { GenderEnum } from "@/enum/symptoms.enum";
import { getBodyCode } from "@/api/symptoms";
import { cloneDeep } from "lodash"

const baseForm = {
        name: "",
        gender: "",
        homeGuide: "",
        plan: "",
        planItemDTOs: [{
            careMethod: "",
            effect: "",
            name: "",
            symptomsImgs: []
        }],
        symptomsCareId: ""
}

const newBaseForm = {
        name: "",
        gender: "",
        homeGuide: "",
        plan: "",
        newPlan: [{
            name: "",
            relationList: [],
        }, {
            name: "",
            relationList: [],
        }],
        symptomsCareId: ""
    }

@Component({
    components: { ETable, EditDialog, ProjectDialog, newProjectDialog }
})
export default class Symptoms extends Mixins(loading, tablePagination, Resize) {

    brandName = this.$route.query.brandName || "";
    merchantId = this.$route.query.merchantId || 0;

    EditDialogVisible: boolean = false;
    ProjectDialogVisible: boolean = false;
    newProjectDialogVisible: boolean = false;
    dialogTitle = "";
    queryForm = {
        name: "",
        bodyCode: "",
        gender: "",
        status: ""
    };
    itemTotal = 0;
    tableData = [];

    columns = [
        { label: "ID", prop: "id" },
        { label: "症状名称", prop: "name" },
        { label: "部位", prop: "", formatter: (row: any) => row.bodyNamesList.join("，") },
        { label: "适用性别", prop: "", formatter: (row: any) => GenderEnum[row.gender] },
        { label: "状态", prop: "status" },
        { label: "操作人", prop: "modifiedBy" },
        { label: "最后操作时间", prop: "modifiedTime" },
        { label: "操作", prop: "action" }
    ]

    symptomsData = {
        id: "",
        name: "",
        title: "",
        gender: 0,
        bodyCodes: [],
        imgUrl: [],
        remark: "",
        common: "",
        status: true,
        symptomsImgs: [
            {
                name: "",
                imgUrl: [],
                objType: 0
            },
            {
                name: "",
                imgUrl: [],
                objType: 0
            },
            {
                name: "",
                imgUrl: [],
                objType: 0
            }
        ],
        unhealthy: ""
    }

    projectData = {
        name: "",
        gender: "",
        homeGuide: "",
        plan: "",
        planItemDTOs: [{
            careMethod: "",
            effect: "",
            name: "",
            symptomsImgs: []
        }],
        symptomsCareId: ""
    }

    newProjectData = {
        name: "",
        gender: "",
        homeGuide: "",
        plan: "",
        newPlan: [{
            name: "",
            relationList: [],
        }, {
            name: "",
            relationList: [],
        }],
        symptomsCareId: ""
    }
    
    genderOptions = [
        {
            value: 0,
            label: "通用",
        },
        {
            value: 1,
            label: "男",
        },
        {
            value: 2,
            label: "女",
        }
    ]
    
    bodyNameList = []

    statusOptions = [
        {
            value: 0,
            label: "禁用",
        },
        {
            value: 1,
            label: "启用",
        }
    ]

    mounted() {
        this.windowResize(320);
        this.getData();
    }

    searchData() {
        this.resetCurrent();
        this.getData();
    }
    getData() {
        const params = {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            merchantId: this.merchantId,
            ...this.queryForm,
        }
        this.showLoading();

        symptomsInfoList(params).then((res) => {
            // res.data.list.forEach((el) => {
            //     el.groupTypeDesc = this.groupTypeOptions.find(item => item.value == el.groupType).label;
            // })
            this.tableData = res.data.list;
            this.itemTotal = res.data.total;
        })
    }

    handleEnableState(row) {
        updateStatus({ symptomsCareId: row.id, status: row.status });
        this.getData();
    }

    goProject(row, key: string) {
        this[key] = true;
        if (key == 'ProjectDialogVisible') {
            this.setOldPlanForm(row);
        }
        if (key == "newProjectDialogVisible") {
            this.setNewPlanForm(row);
        }

    }

    setOldPlanForm(row) {
        getPlanById({ symptomsCareId: row.id, merchantId: this.merchantId }).then((res) => {
            this.projectData = res.data || cloneDeep(baseForm);
            const { planItemDTOs } = this.projectData;
            const _planItemDTOs = planItemDTOs?.map((plan) => {
                return {
                    ...plan,
                    symptomsImgs: plan?.symptomsImgs?.map((IMG: any) => ({ url: IMG.imgUrl }))
                }
            })
            Object.assign(this.projectData, { ...res.data, name: row.name, gender: row.gender,symptomsCareId: row.id, planItemDTOs: _planItemDTOs });
        })
    }

    setNewPlanForm(row) {
        console.log(row)
        getNewPlanById({ symptomsCareId: row.id, merchantId: this.merchantId }).then((res) => {
            this.newProjectData = res.data || cloneDeep(newBaseForm);
            const { newPlan } = res.data;
            newPlan?.forEach((plan) => {
                plan.relationList = plan.relationList?.map((p) => p.productId);
            })
            Object.assign(this.newProjectData, { name: row.name, 
                newPlan: res.data?.newPlan || [{}, {}], 
                gender: row.gender,symptomsCareId: row.id })
        })
    }

    handleEdit(row) {
        this.dialogTitle = row.id ? "编辑" : "新增";
        if (row.id) {
            this.$nextTick(() => {
                getSymptomsById({ symptomsCareId: row.id }).then((res) => {
                    const { imgUrl, status, symptomsImgs } = res.data;
                    const imgs = symptomsImgs.map((el) => ({ ...el, imgUrl: [{url: el.imgUrl}] }));
                    Object.assign(this.symptomsData, { ...res.data, status: Boolean(status), imgUrl: [{url: imgUrl}], symptomsImgs: imgs })
                })
            })
        }
        else {
            this.symptomsData.id = "";
        }
        this.EditDialogVisible = true;
    }

    editConfirm() {
        this.getData();
        this.EditDialogVisible = false;
        this.ProjectDialogVisible = false;
    }

    getBodyNameList() {
        getBodyCode().then((res) => {
            this.bodyNameList = res.data;
        })
    }

}

